import { render } from "./Security.vue?vue&type=template&id=05a1e2a8&scoped=true&ts=true"
import script from "./Security.vue?vue&type=script&lang=ts"
export * from "./Security.vue?vue&type=script&lang=ts"

import "./Security.vue?vue&type=style&index=0&id=05a1e2a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a1e2a8"]])

export default __exports__